import React from "react";
import {Navigate, Outlet, Route, createBrowserRouter, createRoutesFromElements} from "react-router-dom";
import {CourseLibraryPage} from "./pages/CourseLibrary/CourseLibraryPage";
import {ForgottenPasswordPage} from "./pages/ForgottenPassword/ForgottenPassword";
import {ResetPasswordPage} from "./pages/ResetPassword/ResetPassword";
import {CourseLibraryProductPage} from "./pages/CourseLibraryProduct/CourseLibraryProductPage";
import {CoursePage} from "./pages/CoursePage/CoursePage";
import {RxdCoursePage} from "./pages/RxdCoursePage";
import {LoginPage} from "./pages/LoginPage/LoginPage";
import {MyProgressPage} from "./pages/MyProgressPage/MyProgressPage";
import {NotFoundPage} from "./pages/NotFoundPage/NotFoundPage";
import {SandboxPage} from "./pages/Sandbox/sandboxPage";
import {RequireAuth} from "./routes/RequireAuth";
import {ContentManager} from "./pages/ManagerView/ContentManager";
import {TrainingFeedPage} from "./pages/TrainingFeedPage/TrainingFeedPage";
import {SettingsPage} from "./pages/Settings/SettingsPage";
import AppUrlListener from "./routes/AppUrlListener";
import {MyNotesPage} from "./pages/MyNotesPage/MyNotesPage";
import {AnnouncementLandingPage} from "./pages/ModulePage/AnnouncementPage/AnnouncementLandingPage";
import {FeedLandingPage} from "./pages/FeedLandingPage";
import {RootLayout} from "./RootLayout";
import {RxdLayout} from "./RxdLayout";
import useSnackbarManager from "./snackbars/useSnackbarManager";
import {LessonDetail} from "@/pages/RxdCoursePage/LessonDetail";
import {HomePage} from "@/pages/HomePage/HomePage";

export const router = createBrowserRouter(
	createRoutesFromElements(
		<>
			{/* RXD routes - standalone without RootLayout */}
			<Route path="/rxd/:courseSlug/*" element={
				<RxdLayout>
					<RxdCoursePage />
				</RxdLayout>
			} />

			<Route path="/module/:id" element={<RxdLayout>
				<LessonDetail />
			</RxdLayout>} />

			{/* Main app routes with RootLayout */}
			<Route element={<RootLayout />}>
				<Route index element={<LoginPage />} />
				<Route path="/callback" element={<LoginPage />} />
				<Route path="/forgotten-password" element={<ForgottenPasswordPage />} />
				<Route path="/reset-password" element={<ResetPasswordPage />} />
				<Route path="/training-feed" element={<RequireAuth><TrainingFeedPage /></RequireAuth>} />
				<Route path="/home" element={<RequireAuth><HomePage /></RequireAuth>} />
				<Route path="/my-progress" element={<RequireAuth><MyProgressPage /></RequireAuth>} />
				<Route path="/notes" element={<RequireAuth><MyNotesPage /></RequireAuth>} />
				<Route path="/admin/" element={<Navigate to="/admin/users" replace />} />
				<Route path="/admin/*" element={<RequireAuth><ContentManager /></RequireAuth>} />
				<Route path="/course-library" element={<RequireAuth><CourseLibraryPage /></RequireAuth>} />
				<Route path="/course-library/:courseSlug/*" element={<RequireAuth><CourseLibraryProductPage /></RequireAuth>} />
				<Route path="/course/:courseSlug/*" element={<RequireAuth><CoursePage /></RequireAuth>} />
				<Route path="/feed/announcement/:slug/*" element={<RequireAuth><AnnouncementLandingPage /></RequireAuth>} />
				<Route path="/feed/:courseSlug/*" element={<RequireAuth><CoursePage /></RequireAuth>} />
				<Route path="/feed" element={<RequireAuth><FeedLandingPage /></RequireAuth>} />
				<Route path="/settings" element={<RequireAuth><SettingsPage /></RequireAuth>} />
				<Route path="/sandbox" element={<SandboxPage />} />
				<Route path="*" element={<NotFoundPage />} />
			</Route>
		</>
	)
);

const Main: React.FC = () => {
	useSnackbarManager();

	return (
		<main style={{height: "100%"}}>
			<AppUrlListener></AppUrlListener>
			<div className="App">
				<Outlet />
			</div>
		</main>
	);
};

export default Main;